import React from 'react';
import AvatarIcon from 'components/features/utils/AvatarIcon';
import { useParams } from 'react-router-dom';
import { useRouting } from 'hooks/useRouting';
import { useCustomHeaderTitle } from 'hooks/useCustomHeaderTitle';
import { commaFormat } from 'components/features/new-report/utils/formatter';

const HowToIncreaseAccumulationAmount = (): React.ReactElement => {
  const { id } = useParams<{ id: string }>();
  useCustomHeaderTitle('家計の見直し');

  const routing = useRouting();
  const goBack = () => {
    routing.pushRouting({ path: `/target/${id}` }, true);
  };

  const paymentRowInfos = [
    { title: '電気代', amount: 11956 },
    { title: 'ガス代', amount: 5632 },
    { title: '水道代', amount: 5525 },
    { title: '通信費', amount: 11240 },
    { title: '食費（四人家族）', amount: 86245 },
    { title: '外食（四人家族）', amount: 17412 },
  ];

  return (
    <>
      <div className="text-bluegray-700 p-4 bg-white">
        <div className="text-xs">毎月のつみたて額を増やすには?</div>
        <div className="text-lg font-bold">家計の見直しをしましょう</div>
        <div className="text-sm mt-2 mb-4">
          家計から出ていくお金を減らしてつみたてに回しましょう。あなたの家計を、他の人と比較して使いすぎていないかチェックして、見直しに役立ててください。
        </div>
        <div className="mt-5 mb-1 flex-row flex items-baseline">
          <div className="text-base font-bold">主な家計の支出平均額</div>
          <div className="text-xs">（4人世帯 全国平均）※1 </div>
        </div>
        <div className="px-4 pb-5 pt-3 text-white bg-blue-650 rounded-lg">
          {paymentRowInfos.map(
            (props: { title: string; amount: number }, i) => {
              return <PaymentRow {...props} key={i} />;
            }
          )}
        </div>

        <div className="mt-5 p-4 rounded-lg review-point">
          <div className="mb-1 flex-row flex">
            <AvatarIcon icon="average" />
            <div className="ml-4">
              <div className="text-xs font-bold text-teal-500">
                見直しのポイント
              </div>
              <div className="text-sm font-bold mt-1">
                大事なのは「無理なく」！
              </div>
            </div>
          </div>
          <div className="text-sm">
            まずは固定費からチェックすることがおすすめです。平均額を上回っているものがあれば、「やめる・減らす」か「他のもの（サービス）で代替」を検討しましょう。
            <br />
            長く続けることが大切です。無理のない範囲で見直しましょう。
          </div>
        </div>

        <div className="mt-4 text-xs text-bluegray-500">
          ※1 参照：政府統計の総合窓口（ｅ－Ｓｔａｔ）
          <br />
          公開日2023年「第３－８表　４人世帯（有業者１人）世帯主の年齢階級別１世帯当たり１か月間の収入と支出」
        </div>

        <button
          className="mt-4 p-2 font-bold text-bluegray-500 justify-center w-full text-sm"
          onClick={goBack}>
          戻る
        </button>
      </div>
    </>
  );
};

const PaymentRow = (props: { title: string; amount: number }) => {
  const amount = commaFormat(props.amount, { numberOfDecimals: 0 });

  return (
    <>
      <div className="mt-1 px-2 flex-row flex expense-under-line">
        <div className="text-sm font-bold">{props.title}</div>
        <div className="ml-auto flex-row flex items-baseline">
          <div className="text-base font-bold">{amount}</div>
          <div className="text-xs ml-1">円/月</div>
        </div>
      </div>
    </>
  );
};

export default HowToIncreaseAccumulationAmount;
